export default __webpack_public_path__ + "static/media/marauders-map-v5.0-gallery-04.21c9eed5.jpg";